import React, { useEffect, useState } from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Checkbox, DatePicker, Dropdown, Form, Input, InputNumber, MenuProps, Modal, Select, Space, Table, Tooltip } from "antd";
import "./purchase_order.css";
import withPurchaseOrderLogic from "../../components/hoc_purchase_order";
import ModalPurchaseRequest from "./modal_purchase_request";
import ModalPoDataSupplier from "./modal_po_data_supplier";
import EditTablePurchaseOrder from "./edit_table_purchase_order";

const PurchaseOrder: React.FC<any> = (props) => {
    const {
        columns,
        dataSource,
        rowSelection,
        brandOptions,
        profitCenterOptions,
        orderTypeOptions,
        topCodeOptions,
        warehouseOptions,
        handleOrderTypeChange,
        form,
        isModalVisible,
        showModal,
        handleImport,
        handleCancel,
        handleWarehouseChange,
        modalSelectedKeys,
        setModalSelectedKeys,
        orderTypeForModal,
        warehouseCodeForModal,
        isSupplierModalVisible,
        showSupplierModal,
        handleSupplierSelect,
        handleSupplierModalCancel,
        isEditModalVisible,
        editingRecord,
        handleRowDoubleClick,
        handleEditModalCancel,
        handleEditModalOk,
        handleUseDiscountChange,
        handleDelete,
        handleSubmit,
        handleNew,
        autosaveStatus,
        handlePrint,
        isPrinting,
        handleVoid,
        handleVoidApproval,
        statusCode,
        userData,
        checkPoInGoodsReceive
    } = props;
    const statusValue = Form.useWatch('status', form);
    const orderTypeValue = Form.useWatch('order_type', form);
    const statusLabel = statusValue === '3' ? 'Waiting for Approved' : 'Draft';
    const [voidModalVisible, setVoidModalVisible] = useState(false);
    const [voidType, setVoidType] = useState<'Modify' | 'Cancel'>('Modify');
    const [voidRemark, setVoidRemark] = useState("");

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleDropdownOpenChange = async (nextOpen: boolean) => {
        if (nextOpen) {
            const poNoValue = form.getFieldValue('po_no');
            if (poNoValue) {
                const exists = await checkPoInGoodsReceive(poNoValue);
                if (exists) {
                    Modal.warning({
                        title: 'Peringatan',
                        content: `Nomor Purchase Order ${poNoValue} sudah ada di Goods Receive !, tidak dapat void.`,
                    });
                    setDropdownOpen(false);
                    return;
                }
            }
        }
        setDropdownOpen(nextOpen);
    };

    const handleVoidMenuClick: MenuProps['onClick'] = (e) => {
        const type = e.key as 'Modify' | 'Cancel';
        setVoidType(type);
        setVoidRemark(type);
        setVoidModalVisible(true);
    };

    const voidMenuItems: MenuProps['items'] = [
        { key: 'Modify', label: 'Modify' },
        { key: 'Cancel', label: 'Cancel' },
    ];
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    return (
        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="itq9">
                <div className="gjs-grid-column" id="ie77">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_purchase_order",
                                title: (
                                    <>
                                        <span>Data Purchase Order</span>
                                    </>
                                ),
                            },
                            {
                                href: "#/dashboard/purchase_order",
                                title: "Purchase Order",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="iovz6">
                <div className="gjs-grid-column" id="ig1xv">
                    <Button className="pr-button" onClick={handleNew}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z" clipRule="evenodd" />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg> New
                    </Button>
                    <Button className="pr-button" onClick={handleSubmit} disabled={statusCode !== '1'}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg> Submit
                    </Button>
                    {statusCode === '2' ? (
                        <Dropdown menu={{ items: voidMenuItems, onClick: handleVoidMenuClick }} trigger={['click']} open={dropdownOpen} onOpenChange={handleDropdownOpenChange} getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}>
                            <Button className="pr-button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                </svg> Void
                            </Button>
                        </Dropdown>
                    ) : (
                        <Button className="pr-button" onClick={handleVoid} disabled={statusCode !== '1'}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                            </svg> Void
                        </Button>
                    )}
                    <Button className="pr-button" onClick={handlePrint} disabled={statusCode !== '2'}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z" clipRule="evenodd" />
                        </svg> Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave dihentikan karena status dokumen tidak 'Draft' atau data utama belum lengkap.">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>

            <div className="gjs-grid-row" id="i14t1">
                <div className="gjs-grid-column" id="i4911">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input value={statusLabel} placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="PO No"
                            name="po_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="PO Date"
                            name="po_date"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <DatePicker
                                format="DD/MM/YYYY"
                                placeholder="Select date"
                                style={{ width: "40%", fontSize: "14px" }}
                                popupStyle={{ fontSize: "12px" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Item Group"
                            name="item_group"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Item Group"
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    { value: "1", label: "Inventory" },
                                    { value: "2", label: "Outside Job" },
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Brand"
                            name="brand"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Brand"
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    ...(brandOptions || []),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!brandOptions}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Profit Center"
                            name="profit_center"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    ...(profitCenterOptions || []),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!profitCenterOptions}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="dealer_rep_code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    ...(warehouseOptions || [])
                                        .map((wh: any) => ({
                                            value: wh.warehouse_code,
                                            label: wh.warehouse_name,
                                        })),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!warehouseOptions}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Order Type"
                            name="order_type"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    ...(orderTypeOptions || []),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!orderTypeOptions}
                                disabled={!!orderTypeValue}
                                onChange={(value) => handleOrderTypeChange(value, form)}
                            />
                        </Form.Item>
                        <Form.Item
                            label="TOP Code"
                            name="top_code"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[{ required: true, message: 'Required !' }]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    ...(topCodeOptions || []),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!topCodeOptions}
                            />
                        </Form.Item>
                        <div className="grid-2 custom-info-purchase-order">
                            <label style={{ fontWeight: 600 }}> Deliver Warehouse</label>
                            <Form.Item
                                label="Warehouse"
                                style={{ marginBottom: "5px" }}
                                name="warehouse"
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    style={{ width: "100%" }}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                    options={[{ value: "", label: "--  Empty --" },
                                    ...(warehouseOptions || []).map((wh: any) => ({
                                        value: wh.warehouse_code,
                                        label: wh.warehouse_name,
                                    })),]}
                                    onChange={handleWarehouseChange}
                                    loading={!warehouseOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse Code"
                                name="warehouse_code"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" disabled />
                            </Form.Item>
                            <Form.Item
                                label="Warehouse Name"
                                name="warehouse_name"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" disabled />
                            </Form.Item>
                            <Form.Item
                                label="Address"
                                name="warehouse_address"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" disabled />
                            </Form.Item>
                            <Form.Item
                                label="Contact Person"
                                name="warehouse_contact_person"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" disabled />
                            </Form.Item>
                        </div>
                    </Form>
                </div>
                <div className="gjs-grid-column" id="i182t">
                    <Form
                        form={form}
                        layout="horizontal" style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '180px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-order"
                    >
                        <label style={{ fontWeight: 600 }}> Supplier </label>
                        <Form.Item label="Supplier Code" style={{ marginBottom: "5px", width: "400px" }} >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }} >
                                <Form.Item name="supplier_code" noStyle style={{ width: "85%" }} rules={[{ required: true, message: 'Required !' }]}>
                                    <Input
                                        placeholder="Kode Supplier"
                                        style={{ width: "60%" }}
                                    />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="modal_po_data_supplier"
                                    onClick={showSupplierModal}
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Supplier Name"
                            name="supplier_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Address"
                            name="supplier_address"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Contact Person"
                            name="supplier_contact_person"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Discount"
                            style={{
                                marginBottom: "5px",
                                maxWidth: "66%"
                            }}
                        >
                            <Space>
                                <Form.Item
                                    name="discount"
                                    noStyle
                                >
                                    <Input addonAfter="%" />
                                </Form.Item>
                                <Form.Item
                                    name="use_discount"
                                    valuePropName="checked"
                                    noStyle
                                >
                                    <Checkbox onChange={handleUseDiscountChange}>Use</Checkbox>
                                </Form.Item>
                            </Space>
                        </Form.Item>
                        <div className="grid-3 custom-info-purchase-order">
                            <Form.Item
                                label="Down Payment Request"
                                name="dp"
                                style={{
                                    marginBottom: "5px",
                                }}>
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value!.replace(/,/g, '') as any}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Request Arrival Date"
                                name="request_arrival_date"
                                style={{
                                    marginBottom: "5px",
                                }}
                                rules={[{ required: true, message: 'Required !' }]}
                            >
                                <DatePicker format="DD/MM/YYYY"
                                    style={{ width: '100%' }}
                                    popupClassName="custom-datepicker-small-panel"
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Remark"
                                name="remark"
                                style={{
                                    marginBottom: "5px",
                                }}>
                                <Input.TextArea rows={5} />
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="i5736">
                <div className="gjs-grid-column" id="i3wen">
                    <div style={{ marginTop: "20px", textAlign: "left" }}>
                        <Space>
                            <Button onClick={handleDelete} type="primary" style={{ fontSize: "12px", height: "35px", width: "90px", display: "flex", alignItems: "center", justifyContent: "center" }} icon={
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
                                    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                </svg>} > Delete
                            </Button>
                            <Button id="modal_purchase_request" onClick={showModal} type="primary" style={{ fontSize: "12px", height: "35px", width: "105px", display: "flex", alignItems: "center", justifyContent: "center" }} icon={
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
                                    <path d="M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z" />
                                    <path d="M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z" />
                                </svg>} > Copy PR
                            </Button>
                            <Button type="primary" style={{ fontSize: "12px", height: "35px", width: "140px", display: "flex", alignItems: "center", justifyContent: "center" }} icon={
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
                                    <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm5.845 17.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V12a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z" clipRule="evenodd" />
                                    <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                </svg>}> Get Invoice
                            </Button>
                        </Space>

                        <Table
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={dataSource}
                            size="small"
                            style={{ marginTop: "20px" }}
                            onRow={(record) => ({
                                onDoubleClick: () => {
                                    handleRowDoubleClick(record);
                                },
                            })}
                        />
                    </div>
                </div>
            </div>
            <div className="gjs-grid-row" id="i6vrv">
                <div className="gjs-grid-column" id="i2kj">
                    <Form
                        form={form}
                        layout="horizontal" style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '179px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-order"
                    >
                        <Form.Item label="Sub Total" style={{ marginBottom: "5px", marginTop: "20px" }} name="sub_total">
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value!.replace(/,/g, '') as any}
                                readOnly
                            />
                        </Form.Item>
                        <Form.Item label="Total Discount" style={{ marginBottom: "5px" }} name="total_discount">
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                formatter={value => `${Math.round(value || 0)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value!.replace(/,/g, '') as any}
                                readOnly
                            />
                        </Form.Item>
                        <Form.Item label="VAT" style={{ marginBottom: "5px" }} name="vat_amount">
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                formatter={value => `${Math.round(value || 0)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value!.replace(/,/g, '') as any}
                                readOnly
                            />
                        </Form.Item>
                        <Form.Item label="Total" style={{ marginBottom: "5px" }} name="total_amount">
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                formatter={value => `${Math.round(value || 0)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value!.replace(/,/g, '') as any}
                                readOnly
                            />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <Modal
                title="Data Purchase Request"
                open={isModalVisible}
                onOk={handleImport}
                onCancel={handleCancel}
                width={1000}
                okText="Import"
                okButtonProps={{
                    disabled: modalSelectedKeys.length === 0,
                    style: { fontSize: "10px" }
                }}
                cancelText="Batal"
                cancelButtonProps={{
                    style: { fontSize: "10px" }
                }}
            >
                <ModalPurchaseRequest
                    selectedRowKeys={modalSelectedKeys}
                    onSelectChange={setModalSelectedKeys}
                    orderType={orderTypeForModal}
                    warehouseCode={warehouseCodeForModal}
                    existingPrNos={dataSource.map((item: any) => item.pr_no)}
                />
            </Modal>
            <Modal
                title="Data Supplier"
                open={isSupplierModalVisible}
                onCancel={handleSupplierModalCancel}
                width={1000}
                footer={null}
            >
                <ModalPoDataSupplier onSupplierSelect={handleSupplierSelect} />
            </Modal>
            <Modal
                title="Edit Item Purchase Order"
                className="modal-edit-data-table-purchase-order"
                open={isEditModalVisible}
                onCancel={handleEditModalCancel}
                footer={null}
                width={400}
            >
                <EditTablePurchaseOrder record={editingRecord} onCancel={handleEditModalCancel} onOk={handleEditModalOk} />
            </Modal>
            <Modal
                title={`Konfirmasi Void - ${voidType}`}
                open={voidModalVisible}
                onOk={() => {
                    handleVoidApproval(voidType, voidRemark);
                    setVoidModalVisible(false);
                }}
                onCancel={() => setVoidModalVisible(false)}
                okText="Setuju"
            >
                <p>Remark :</p>
                <Input.TextArea
                    rows={3}
                    value={voidRemark}
                    onChange={(e) => {
                        if (e.target.value.startsWith(voidType)) {
                            setVoidRemark(e.target.value);
                        }
                    }}
                />
            </Modal>
        </div>
    );
};

export default withPurchaseOrderLogic(PurchaseOrder);